import { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { Grid } from '@material-ui/core'

import { isDebug } from '../../../configs'
import { useStudentContext, useSessionContext } from '../../../contexts'

import { getModuleName } from '../../../ModuleNames'
import { getFaultAttemptDetails, getStudentProfileByUserID } from '../../../api/LRS'

import { SimutechModule } from '../../../common/types'
import { FaultAttempt } from '../../../interfaces/Types'

import { DataTile, DataTileType } from '../../dataview'
import { FaultDetailsView } from '.'
import { CriticalError, LoadingIndicator } from '../../'
import { PrimaryHeader, SecondaryHeader } from '../../../styles/Styles'

const FaultDetails = () => {
    const { currentStudent, setCurrentStudent } = useStudentContext()
    const { user } = useSessionContext()

    const [error, setError] = useState('')
    const [faultAttempt, setFaultAttempt] = useState<FaultAttempt>()

    const { studentId, modId, faultAttemptId } = useParams<{
        studentId: string
        modId: SimutechModule
        faultAttemptId: string
    }>()

    const moduleName = getModuleName(modId)
    const fetchingStudent = useRef(false)
    const fetchingDetails = useRef(false)

    useEffect(() => {
        if (!user?.lrsDbName || (currentStudent && currentStudent.userId === studentId) || fetchingStudent.current) return
        fetchingStudent.current = true
        isDebug && console.log('Fetch Student effect for Fault Details studentId :', studentId)
        const fetchData = async () => {
            const student = await getStudentProfileByUserID(studentId, user.lrsDbName)
            setCurrentStudent(student)
        }
        fetchData()
            .catch(error => setError(error.toString()))
    }, [currentStudent, setCurrentStudent, studentId, user?.lrsDbName])

    useEffect(() => {
        if (!user || !currentStudent || faultAttempt || fetchingDetails.current) return
        fetchingDetails.current = true

        const fetchData = async () => {
            const faultAttemptDetails: FaultAttempt[] = await getFaultAttemptDetails(faultAttemptId, user.lmsSessionId)
            if (!faultAttemptDetails[0]) throw new Error('Invalid fault attempt')
            setFaultAttempt(faultAttemptDetails[0])
        }
        fetchData()
            .catch(error => setError(error.toString()))
    }, [currentStudent, faultAttempt, faultAttemptId, user])

    if (error) return <CriticalError message={error} />
    if (!currentStudent || !faultAttempt) return <LoadingIndicator loading={true} text={'Loading fault details...'} />

    return (
        <>
            <Grid container spacing={4} justifyContent={'flex-start'}>
                <Grid item>
                    <DataTile type={DataTileType.Employee} value={0} text={currentStudent.userName.replace(/,/g, ', ')} />
                </Grid>
            </Grid>

            <PrimaryHeader variant={'h4'}>{moduleName}</PrimaryHeader>
            <SecondaryHeader variant={'h5'}>{`Fault Attempt Details`}</SecondaryHeader>

            <FaultDetailsView {...faultAttempt} />

        </>
    )
}

export default FaultDetails
